import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-parent"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"message-row d-flex\"><div class=\"d-flex w-100\"><div class=\"ava-initials\"><span></span></div><div class=\"message-body w-35\"><span class=\"shimmer-loading w-90 lighten\"></span><div class=\"message-content\"><span class=\"shimmer-loading w-60 lighten\"></span></div></div></div></div><div class=\"message-row d-flex flex-row-reverse\"><div class=\"message-body w-35\"><span class=\"shimmer-loading w-90 lighten\"></span><div class=\"message-content\"><span class=\"shimmer-loading w-60 lighten\"></span></div></div></div>", 2)
const _hoisted_6 = [
  _hoisted_4
]
const _hoisted_7 = {
  key: 0,
  class: "message-separator"
}
const _hoisted_8 = {
  key: 0,
  class: "message-separator unread",
  ref: "unReadMessagesBanner"
}
const _hoisted_9 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_UserMessage = _resolveComponent("UserMessage")!
  const _component_OthersMessage = _resolveComponent("OthersMessage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["messages-wrapper", `${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`]),
    ref: "messagesWrapper"
  }, [
    (_ctx.showMessageLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("v-if", true),
    (_ctx.isError && !_ctx.getAreConvMsgsLoading(_ctx.activeConversation?.id))
      ? (_openBlock(), _createBlock(_component_ErrorMessageHandler, {
          key: 1,
          title: "messages",
          "try-again": _ctx.reset
        }, null, 8 /* PROPS */, ["try-again"]))
      : _createCommentVNode("v-if", true),
    (_ctx.getAreConvMsgsLoading(_ctx.activeConversation?.id) && !_ctx.isError)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, _hoisted_6))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (!_ctx.getAreConvMsgsLoading(_ctx.activeConversation?.id) && !_ctx.isError)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createCommentVNode(" READ MESSAGES "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.readMessages, (message, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: message.id
            }, [
              _createCommentVNode(" DATE "),
              (_ctx.showDateBanner(index))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(message.createdOn)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" MESSAGE "),
              _createElementVNode("div", {
                class: _normalizeClass(`message-row d-flex ${message.isFromSelf ? 'flex-row-reverse' : 'flex-row'}`),
                ref_for: true,
                ref: `${_ctx.messageReferences[index]}`
              }, [
                _createCommentVNode(" IS FROM SELF "),
                (message.isFromSelf)
                  ? (_openBlock(), _createBlock(_component_UserMessage, {
                      key: 0,
                      "is-last-message": index === _ctx.lastSelfMessageIndex,
                      "is-group-conversation": _ctx.isGroupConversation,
                      "read-list": _ctx.activeConversation?.readList || [],
                      message: message,
                      "previous-message": _ctx.readMessages[index - 1] || null
                    }, null, 8 /* PROPS */, ["is-last-message", "is-group-conversation", "read-list", "message", "previous-message"]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" FROM OTHERS "),
                      _createVNode(_component_OthersMessage, {
                        message: message,
                        "previous-message": _ctx.readMessages[index - 1] || null
                      }, null, 8 /* PROPS */, ["message", "previous-message"])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              ], 2 /* CLASS */)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createCommentVNode(" BANNER "),
          (_ctx.unReadMessages?.length > 0 && !_ctx.unReadMessages[_ctx.unReadMessages.length - 1].isFromSelf)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.unReadMessages?.length) + " Unread Message" + _toDisplayString(_ctx.unReadMessages?.length > 1 ? "s" : ""), 1 /* TEXT */)
              ], 512 /* NEED_PATCH */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" UNREAD MESSAGES "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unReadMessages, (message, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "message-row d-flex flex-row",
              key: message.id
            }, [
              (!message.isFromSelf)
                ? (_openBlock(), _createBlock(_component_OthersMessage, {
                    key: 0,
                    message: message,
                    "previous-message": _ctx.unReadMessages[index - 1] || null
                  }, null, 8 /* PROPS */, ["message", "previous-message"]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}